import { DataList } from '@brighte/form-components';
import { Stack } from '@spark-web/stack';

export default function StepSummary({ completedContent }) {
  if (!completedContent) return null;

  return (
    <Stack gap="xlarge">
      {completedContent?.map(({ title, items }, index) => (
        <DataList title={title} items={items} key={`${title}-${index}`} />
      ))}
    </Stack>
  );
}
